import React from "react";

import { DashboardPageTemplate } from "../../Utils/DashboardPageTemplate";

export const SubscriptionsDashboard = () => {
  return (
    <DashboardPageTemplate pageName={"subscriptions"} showCogsWarning={true} />
  );
};
